/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React from "react";
import PropTypes from "prop-types";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import axios from "axios";
import utils from "../../utils/utils";
import "./style.less";

const praised_icon = 'https://static.shihuocdn.cn/admin/files/20241029/ccb6c6caff2783d6ee264a93e088af3a.png'//选中后
const un_praised_icon = 'https://static.shihuocdn.cn/admin/files/20241029/437472759078c049024b762b9f409aad.png'//未点赞
const praised_animated = 'https://static.shihuocdn.cn/admin/files/20241029/8a40e7c94f8d375a920c52b5f2ab4207.svga'//点赞动效
const cancel_praised_animated = 'https://static.shihuocdn.cn/admin/files/20241029/f83b3847007875c51b0336c78af12616.svga'//取消点赞

class PipelineCommunityVote extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      status: 0,
      is_vote: 0,
      is_login: false,
      showAnimated: false,
    };
    this.praiseTimer = null;
    this.isAndroid = utils.isAndroid();
    this.pageId = utils.getPageId();
    this.isIphone14ProMax = utils.isIphone14ProMax();
    this.praiseRefMap = {};
    this.praiseImgRefMap = {};
    this.init = false;
    this.lock = false;
    this.delayTimeout = null;
  }

  componentDidMount() {
    this.getCardListData();
    this.peloadingSvg(praised_animated);

    document.addEventListener(
      "visibilitychange",
      () => {
        if (document.hidden) {
          return;
        } else {
          // 刷新秒杀状态
          if (this.delayTimeout) {
            clearTimeout(this.delayTimeout);
            this.delayTimeout = null;
          }
          this.delayTimeout = setTimeout(() => {
            this.getCardListData();
          }, 500);
          return;
        }
      },
      false
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.communityVoteState) {
      this.props.updateCommunityVoteState(false);
      this.getCardListData();
    }
  }

  componentWillUnmount() {
    if (this.delayTimeout) {
      clearTimeout(this.delayTimeout);
      this.delayTimeout = null;
    }
  }

  peloadingSvg = (url) => {//预加载图片资源
    if (this.praiseHiddenRef) {
      import('svgaplayerweb').then((SVGA) => {
        const player = new SVGA.Player(this.praiseHiddenRef);
        const parser = new SVGA.Parser(this.praiseHiddenRef); // 如果你需要支持 IE6+，那么必须把同样的选择器传给 Parser。
        parser.load(url, (videoItem) => {
          player.loops = 1;
          player.setVideoItem(videoItem);
          player.startAnimation();
          player.onFinished(() => {
            player.stopAnimation(true);
            if (url.includes('/8a40e7c94f8d375a920c52b5f2ab4207')) {
              this.peloadingSvg(cancel_praised_animated)
            }
          });
        })
      });
    }
  }

  componentWillUnmount() {
    if (this.praiseTimer) {
      clearTimeout(this.praiseTimer);
      this.praiseTimer = null;
    }
  }

  getCardListData() {
    const defaultList = this.state.list;
    const itemList = this.props.config.itemList;
    const option_ids = itemList.map(item => {
      return item.uid
    })
    axios({
      url: "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/comm/vote/info",
      method: "post",
      withCredentials: true,
      data: {
        special_id: this.pageId,
        option_ids
      },
    }).then((res) => {
      const { status, data } = res.data;
      if (status === 0) {
        let list = data.option_list || [];
        list = itemList.map(item => {
          const target = list.find(value => value.uid == item.uid);
          return target;
        }).filter(item => Boolean(item));
        if (data.status === 2) {
          list = list.sort((a, b) => a.rank - b.rank);
        };
        if (!this.init) {
          if (data.status !== 2) {
            this.init = true;
            list = this.shuffleArray(list);
          }
        } else {
          list = defaultList.map((item) => {
            const target = list.find(value => value.uid === item.uid);
            if (target) {
              item = target;
            }
            return item;
          });
        }
        this.setState({
          is_vote: data.is_vote,
          status: data.status,
          is_login: Boolean(data.uid),
          list
        }, () => {
          window.isLogin = Boolean(data.uid);
        })
      }
    });
  }

  // 投票
  handleVoteClick = async(uid) => {
    if (this.lock) {
      return;
    }
    this.lock = true;

    const { is_login } = this.state;

    if (!is_login) {
      // 未登录
      this.lock = false;
      window.Jockey.send("action", {
        url: "shihuo://www.shihuo.cn?route=login",
      });
      return;
    }
    axios({
      url: "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/comm/vote",
      method: "post",
      withCredentials: true,
      data: {
        special_id: this.pageId,
        option_id: uid
      },
    }).then((res) => {
      const { status, msg } = res.data;
      if (status === 0) {
        // 投票成功后刷新列表数据及投票资格
        this.props.updateCommunityVoteState(true);
        this.props.updateLotteryState(true);
      } else {
        window.Jockey.send('toast', {
          text: msg
        });
      }
      this.lock = false;
    }).catch(err => {
      this.lock = false;
    });
  }

  showPraiseSvga = (svgaUrl, id) => {
    let praiseRef = this.praiseRefMap[id]
    let praiseIconRef = this.praiseImgRefMap[id]
    if (praiseRef) {
      import('svgaplayerweb').then((SVGA) => {
        praiseRef.style.display = "flex";
        praiseIconRef.style.display = "none";
        const player = new SVGA.Player(praiseRef);
        const parser = new SVGA.Parser(praiseRef); // 如果你需要支持 IE6+，那么必须把同样的选择器传给 Parser。
        parser.load(svgaUrl, (videoItem) => {
          player.loops = 1;
          
          player.setVideoItem(videoItem);
          player.startAnimation();
          player.onFinished(() => {
            praiseRef.style.display = "none";
            praiseIconRef.style.display = "flex";
            player.stopAnimation(true);
          });
        })
      });
    }
  }

  handlePraiseClick(event, id, channel_type, status, value, key, item, index) {
    let { list } = this.state;
    event.stopPropagation();
    const reqUrl = "https://sh-gateway.shihuo.cn/v3/apps/app_swoole_common/praise";
    axios({
      url: reqUrl,
      method: "get",
      withCredentials: true,
      params: {
        id,
        channel_type,
        status
      },
    }).then((res) => {
      const { data = {} } = res
      if (data.status == 0) {
        if (value.is_like === 1) {
          value.is_like = 0;
          value.like_num = Number(value.like_num) - 1;
          value.like_num_text = this.formatPraiseNum(value.like_num);
          list[index].note_list[key] = value;
          this.setState({list})
          this.showPraiseSvga(cancel_praised_animated, id)
        } else {
          value.is_like = 1;
          value.like_num = Number(value.like_num) + 1;
          value.like_num_text = this.formatPraiseNum(value.like_num);
          list[index].note_list[key] = value;
          this.setState({list})
          this.showPraiseSvga(praised_animated, id)
        }
      } else if (data.status == 3) {
        window.Jockey.send("action", {
          url: "shihuo://www.shihuo.cn?route=login"
        });
      }
    });
  }

  handleItemClick(item, index) {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.href,
        props: this.props,
        index
      })
      return
    }

    const baseConfig = this.props.config.baseConfig;

    const options = {
      title: baseConfig.title,
      sort: index,
    };

    utils.jumpToUrl(this.props.routeParams, item.href, item.href, options, item.id, this.props);
  }

  handJumpHomeInfo = (href) => {
    utils.jumpToUrl(this.props.routeParams, href, href, {}, -1, this.props);
  }

  formatPraiseNum = (praise) => {
    if (typeof praise === 'number' && praise > 9999) {
      praise = parseFloat((praise / 10000).toFixed(1)) + 'w';
    }
    return praise;
  }

  renderVoteState(item) {
    const { voteConfig } = this.props.config;
    const { status, is_vote } = this.state;
    if (status !== 2) {
      // 活动未开始或进行中
      if (item.status === 0) {
        // 当日未投票
        if (is_vote !== 1) {
          // 本天/本周期 未投票
          return (
            <div className="vote-area type-1">
              <div
                className="vote-btn"
                style={{
                  backgroundColor: voteConfig.btnBgColor,
                  color: voteConfig.btnTextColor
                }}
                onClick={() => this.handleVoteClick(item.uid)}
              >
                  投票
                </div>
            </div>
          )
        } else {
          // 本天/本周期 已投票
          return (
            <div className="vote-area type-2">
              <p className="vote-num">{item.vote_num}<span>票</span></p>
              <div
                className="vote-btn"
                style={{
                  backgroundColor: voteConfig.btnBgColor,
                  color: voteConfig.btnTextColor
                }}
                onClick={() => this.handleVoteClick(item.uid)}
              >
                投票
              </div>
            </div>
          )
        }
      } else if (item.status === 1) {
        // 已投票
        return (
          <div className="vote-area type-3">
            <p className="vote-num">{item.vote_num}<span>票</span></p>
            <div className="has-voted">
              <img src="https://static.shihuocdn.cn/admin/files/20241216/e5d45fe8642241ab180392cf15b541d0.png" alt="" className="icon" />
              已投票
            </div>
          </div>
        )
      } else if (item.status === 2) {
        // 无余票（当天已投完）
        return (
          <div className="vote-area type-4">
            <p className="vote-num">{item.vote_num}<span>票</span></p>
            <div className="vote-btn disabled" onClick={() => this.getVoteToastText()}>投票</div>
          </div>
        )
      } else if (item.status === 3) {
        // 活动已结束
        return (
          <div className="vote-area type-5">
            <p className="ranking">第{item.rank}名</p>
            <p className="vote-num">{item.vote_num}票</p>
            <p className="status">活动已结束</p>
          </div>
        )
      } else {
        return null
      }
    } else {
      // 活动已结束
      return (
        <div className="vote-area type-5">
          <p className="ranking">第{item.rank}名</p>
          <p className="vote-num">{item.vote_num}票</p>
          <p className="status">活动已结束</p>
        </div>
      )
    }
  }

  render() {
    const { baseConfig, voteConfig } = this.props.config;
    const { status, is_vote, list = [] } = this.state; 
    return (
      <div
        ref={ele => {
          if (ele) {
            this.props.exp && this.props.exp(ele);
          }
        }}
        data-dot={JSON.stringify(utils.getExposureData(this.props))}
        className="pipeline-communityVote"
        id={this.props['customAttributes']['data-component-id']}
        name={baseConfig.title}
        {...this.props['customAttributes']}
        style={{
          paddingTop: baseConfig.moduleMarginTop >= 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginTop: baseConfig.moduleMarginTop < 0 ? `${baseConfig.moduleMarginTop}px` : 0
        }}
      >
        {
          list.map((item, index) => {
            return (
              <div
                className="user-note"
                key={`item-${index}`}
              >
                <div className={`head-vote ${this.isAndroid ? 'android' : 'ios'}`}>
                  <div className="user-info" onClick={() => this.handJumpHomeInfo(item.href)}>
                    <img src={item.avatar} alt="" className="avatar" />
                    <div className="info">
                      <p className="user-name">{item.username}</p>
                      <p className="signature">{item.sign}</p>
                    </div>
                  </div>
                  { this.renderVoteState(item) }
                  {
                    (status !== 2 && is_vote === 1) && <div className="rank">当前第{item.rank}名</div>
                  }
                </div>
                <div className="scroll-content">
                  <ul>
                    {
                      item.note_list && item.note_list.length > 0 && item.note_list.map((value, key) => {
                        return (
                          <li key={`user-${index}-note-${key}`} onClick={() => this.handleItemClick(value, key)}>
                            <div className="note-img-wrap">
                              <LazyLoadImage effect="opacity" src={utils.formatImgUrl(value.pic, this.props.webpSupport, 'card')} alt="" className="note-img" />
                              {
                                value.is_video === 1 &&
                                  <img src="https://static.shihuocdn.cn/admin/files/20240506/37c435801c77b97c25a32861a0e26148.png" alt="" className="video-logo" />
                              }
                            </div>
                            <div className="note-info">
                              <p className="note-title">{value.title}</p>
                              <div className="note-author">
                                <div className="user-info">
                                  <img src={value.avatar} alt="" className="avatar" />
                                  <p className={this.isAndroid ? 'username android' : 'username ios'}>{value.username}</p>
                                </div>
                                <div className="praise-info" onClick={(event) => this.handlePraiseClick(event, value.id, 4, value.is_like === 0 ? 1 : 2, value, key, item, index)}>
                                  <div className='praise-icon-content'>
                                    <img
                                      className={"praise-icon"}
                                      src={value.is_like === 1 ? praised_icon : un_praised_icon}
                                      alt=""
                                      id={`praise-icon-${value.id}`}
                                      ref={r=> {this.praiseImgRefMap[value.id] = r}}
                                    />
                                    <div
                                      className="praise-icon-svga"
                                    >
                                      <div style={{ width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center'}} id={`praise-icon-svga-${value.id}`} ref={r=> {this.praiseRefMap[value.id] = r}}/>
                                    </div>
                                  </div>
                                  <p className={this.isAndroid ? 'praise-num android' : 'praise-num ios'}>{this.formatPraiseNum(value.like_num)}</p>
                                </div>
                              </div>
                            </div>
                          </li>
                        )
                      })
                    }
                  </ul>
                </div>
              </div>
            )
          })
        }
        <div style={{ width: 0, height: 0, overflow: 'hidden', position: 'absolute', left: 0, top: 0}} ref={ref => this.praiseHiddenRef = ref} />
      </div>
    );
  }

  // 获取投票toast文案
  getVoteToastText = () => {
    const { voteConfig } = this.props.config;
    if (voteConfig.endTime) {
      const endTime = new Date(voteConfig.endTime);

      // 获取当前时间（本地时间）
      const now = new Date();

      // 将截止时间转换为本地时间  
      const deadlineLocalYear = endTime.getFullYear();
      const deadlineLocalMonth = endTime.getMonth() + 1;
      const deadlineLocalDate = endTime.getDate();

      // 获取当前日期的年份、月份和日期  
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth() + 1;
      const currentDate = now.getDate();  

      let toast = '';

      // 判断当前日期是否在截止日期之前  
      if (
        (currentYear < deadlineLocalYear) ||   
        (currentYear === deadlineLocalYear && currentMonth < deadlineLocalMonth) ||   
        (currentYear === deadlineLocalYear && currentMonth === deadlineLocalMonth && currentDate < deadlineLocalDate)
      ) {  
        // 按日且今日不是活动周期的最后一天：“今日票数已用尽，明天再来吧～”
        toast = '今日票数已用尽，明天再来吧～';
      } else {  
        // 按活动总周期投票/按日且今日为活动周期的最后一天：“投票次数已用尽，下次再来吧～”
        toast = '投票次数已用尽，下次再来吧～';
      }

      window.Jockey.send('toast', {
        text: toast
      });
    }
  }

  // 数组随机打散
  shuffleArray = (array) => {
    if (array.length <= 0) {
      return array;
    }
    // 创建数组的副本，以避免修改原数组
    let shuffledArray = array.slice();

    for (let i = shuffledArray.length - 1; i > 0; i--) {  
      // 生成 [0, i] 之间的随机索引  
      const j = Math.floor(Math.random() * (i + 1));
      
      // 交换元素  
      [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
    }  

    return shuffledArray;  
  } 

  // 数组随机打散
  // shuffleArray = (array, is_vote) => {
  //   if (array.length <= 0) {
  //     return array;
  //   }

  //   let hasVoteArr = [], notVoteArr = []; // 定义未投票和已投票的数据

  //   if (is_vote === 1) {
  //     // 已投票状态下，先把投过票的达人按照顺序提取出来放在最前面，剩余未给予投票的达人随机打散放在后面
  //     for (const item of array) {
  //       if (item.status === 0) {
  //         // 未投票
  //         notVoteArr.push(item);
  //       } else {
  //         hasVoteArr.push(item);
  //       }
  //     }
  //   } else {
  //     notVoteArr = array;
  //   }

  //   // 创建数组的副本，以避免修改原数组
  //   let shuffledArray = notVoteArr.slice();

  //   for (let i = shuffledArray.length - 1; i > 0; i--) {  
  //     // 生成 [0, i] 之间的随机索引  
  //     const j = Math.floor(Math.random() * (i + 1));
      
  //     // 交换元素  
  //     [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
  //   }

  //   const resultArr = [...hasVoteArr, ...shuffledArray];

  //   return resultArr;  
  // } 
}

PipelineCommunityVote.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineCommunityVote };
export default PipelineCommunityVote;



// WEBPACK FOOTER //
// ./components/pipeline-communityVote/index.js